import script from "./TwistHoleController.vue?vue&type=script&setup=true&lang=js"
export * from "./TwistHoleController.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__